module.exports = __webpack_public_path__ + "media/ענן.b23b92cf.mp3";